import api from "../../services/api";

// mesma estrutura do slotsCache

let abas = null;
let carregando = null;
let erro = null;
const inscritos = new Set();

function notificar() {
    for (const fn of inscritos) fn();
}

export function getSnapshot() {
    return { abas, erro, carregando: Boolean(carregando) };
}

export function subscribe(fn) {
    inscritos.add(fn);
    return () => inscritos.delete(fn);
}

export function carregarAbas({ force = false } = {}) {
    if (!force && abas) return Promise.resolve(abas);
    if (!force && carregando) return carregando;

    erro = null;
    notificar();

    carregando = api
        .post("/schema/getAbasSchema", {})
        .then((response) => {
            abas = response?.data?.abas || [];
            return abas;
        })
        .catch((e) => {
            erro = e;
            throw e;
        })
        .finally(() => {
            carregando = null;
            notificar();
        });

    return carregando;
}

function substituirLista(proxima) {
    abas = proxima;
    notificar();
}

export async function criarAba({ key, label, descricao }) {
    const response = await api.post("/schema/postAbaSchema", {
        key,
        label,
        descricao,
    });

    const criada = response?.data?.aba;
    if (!criada) return null;

    const atuais = abas || [];
    const jaTem = atuais.some((aba) => aba.id === criada.id);
    substituirLista(
        jaTem
            ? atuais.map((aba) => (aba.id === criada.id ? criada : aba))
            : [...atuais, criada],
    );

    return { aba: criada, created: Boolean(response?.data?.created) };
}

export async function atualizarAba({ id, label, descricao, key, ordem }) {
    const response = await api.put("/schema/putAbaSchema", {
        id,
        label,
        descricao,
        key,
        ordem,
    });

    const atualizada = response?.data?.aba;
    if (!atualizada) return null;

    substituirLista(
        (abas || []).map((aba) => (aba.id === atualizada.id ? atualizada : aba)),
    );

    return atualizada;
}

export async function excluirAba({ id, force = false }) {
    await api.post("/schema/deleteAbaSchema", { id, force });
    substituirLista((abas || []).filter((aba) => aba.id !== id));
}

export function invalidarAbas() {
    abas = null;
    carregando = null;
    erro = null;
    notificar();
}
